import {Action} from "@ngrx/store";
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS: string = '[ecommerce performance report orders] Load Ecommerce Performance Report Orders';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_SUCCESS: string = '[ecommerce performance report orders] Load Ecommerce Performance Report Orders Success';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_FAIL: string = '[ecommerce performance report orders] Load Ecommerce Performance Report Orders Fail';

export class LoadEcommercePerformanceReportOrders implements Action {
  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommercePerformanceReportOrdersSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_SUCCESS;

  constructor(public payload: {
    ordersData: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePerformanceReportOrdersFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_FAIL;

  constructor(public payload: any) {
  }

}


export type EcommercePerformanceReportOrdersAction = LoadEcommercePerformanceReportOrders | LoadEcommercePerformanceReportOrdersSuccess | LoadEcommercePerformanceReportOrdersFail;
